import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function UserView() {
  const { id } = useParams(); // Get the user ID from the URL
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const { data, error } = await supabase
          .from("profiles")
          .select("*")
          .eq("user_id", id)
          .single();

        if (error) throw error;
        setProfile(data);
      } catch (err) {
        console.error("Error loading user profile:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [id]);

  if (loading) {
    return (
      <div
        style={{
          backgroundColor: "#246e31ff",
          color: "white",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h2>Loading user profile...</h2>
      </div>
    );
  }

  if (!profile) {
    return (
      <div
        style={{
          backgroundColor: "#246e31ff",
          color: "white",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h2>User not found 😢</h2>
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#246e31ff",
        color: "white",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          color: "#246e31ff",
          borderRadius: "12px",
          padding: "2rem",
          width: "90%",
          maxWidth: "400px",
          textAlign: "center",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
        }}
      >
        {profile.avatar_url && (
          <img
            src={profile.avatar_url}
            alt="Profile"
            style={{
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              marginBottom: "1rem",
              objectFit: "cover",
            }}
          />
        )}
        <h2>{profile.full_name}</h2>
        <p style={{ margin: "0.5rem 0" }}>
          <strong>Faculty:</strong> {profile.faculty || "Not set"}
        </p>
        <p style={{ margin: "0.5rem 0" }}>
          <strong>Situation:</strong> {profile.situation || "Not set"}
        </p>
        <p style={{ marginTop: "1rem", fontSize: "1.2rem" }}>
          <strong>Points:</strong> {profile.points ?? 0} ⭐
        </p>
      </div>
    </div>
  );
}
